import React, { useState } from "react";

const allServices = [
  {
    domaine: "🧑‍💻 IT & Dev",
    service: "Environnement Dev",
    description: "IDE, Git, outils de build",
    tarif: "30 DT",
    url: "https://docs.google.com/forms/d/e/1FAIpQLSdEmiWywRrgyZuweVShW9ENBvc0g7zxxyFRXjnz_hyaU0k8Dg/viewform?usp=pp_url&entry.2044055668=🧑‍💻+IT+%26+Dev+—+Environnement+Dev",
    note: `Installation de l'environnement complet pour le développement logiciel.\n
    + IDE modernes (Visual Studio Code, IntelliJ, etc.)\n
    + Gestion de versions Git (avec configuration GitHub / GitLab)\n
    + Intégration d’outils de build (npm, Maven, etc.)\n
    + Tarification : 30 DT \n
    + N.B : Les outils à préciser selon le projet du stagiaire . \n 
    + Objectif : améliorer la productivité et standardiser les environnements.`
  },
  {
    domaine: "🧑‍💻 IT & Dev",
    service: "Formation Git & GitHub",
    description: "Cours + intégration Git",
    tarif: "25 DT / session",
    url:
      "https://docs.google.com/forms/d/e/1FAIpQLSdEmiWywRrgyZuweVShW9ENBvc0g7zxxyFRXjnz_hyaU0k8Dg/viewform?usp=pp_url&entry.2044055668=%F0%9F%A7%91%E2%80%8D%F0%9F%92%BB+IT+%26+Dev+%E2%80%94+Formation+Git+%26+GitHub",
    note:
      "Session de formation pratique sur Git et GitHub pour maîtriser la gestion de versions et le travail collaboratif.",
  },
  {
    domaine: "☁️ Hébergement",
    service: "Hébergement Web (Basic)",
    description: "Hébergement site web basique",
    tarif: "40 DT / mois",
    url:
      "https://docs.google.com/forms/d/e/1FAIpQLSdEmiWywRrgyZuweVShW9ENBvc0g7zxxyFRXjnz_hyaU0k8Dg/viewform?usp=pp_url&entry.2044055668=%E2%98%81%EF%B8%8F+H%C3%A9bergement+%E2%80%94+H%C3%A9bergement+Web+(Basic)",
    note:
      "Hébergement fiable pour sites web simples avec support technique, parfait pour les petits projets.",
  },
  {
    domaine: "☁️ Hébergement",
    service: "Hébergement API (Standard)",
    description: "Hébergement cloud d'API pour projets web",
    tarif: "45 DT / mois",
    url: "https://docs.google.com/forms/d/e/1FAIpQLSdEmiWywRrgyZuweVShW9ENBvc0g7zxxyFRXjnz_hyaU0k8Dg/viewform?usp=pp_url&entry.2044055668=☁️+Hébergement+—+Hébergement+API+(Standard)",
    note: `Service d’hébergement d’API (type Azure App Service - Basic).\n
      + Environnement cloud dédié pour déployer vos API REST.\n
        + Idéal pour les prototypes, les environnements de test ou les petits projets en production.\n`
  },
  {
    domaine: "☁️ Hébergement",
    service: "Nom de domaine personnalisé",
    description: "Nom de domaine sur mesure",
    tarif: "15 DT / an (avec gestion) ou 10 DT / an (sans gestion)",
    url: "https://docs.google.com/forms/d/e/1FAIpQLSdEmiWywRrgyZuweVShW9ENBvc0g7zxxyFRXjnz_hyaU0k8Dg/viewform?usp=pp_url&entry.2044055668=%E2%98%81%EF%B8%8F+H%C3%A9bergement+%E2%80%94+Nom+de+domaine+personnalis%C3%A9",
    note: `Deux options disponibles pour le nom de domaine personnalisé : 
    + 15 DT / an : Gestion et administration complètes incluses via notre service (configuration DNS, renouvellement, support, sécurité). 
    + 10 DT / an : Achat seul sans gestion ni administration, vous gérez vous-même la configuration, le renouvellement et le support.
    N.B : Les frais de l'achat du nom de domaine ne sont pas comptabilisés dans ces frais.`,
  },
  {
    domaine: "🤖 IoT",
    service: "Séance ponctuelle – Location IoT",
    description: "Location de matériel IoT pour une séance unique",
    tarif: "15 DT / séance",
    url: "https://docs.google.com/forms/d/e/1FAIpQLSdEmiWywRrgyZuweVShW9ENBvc0g7zxxyFRXjnz_hyaU0k8Dg/viewform?usp=pp_url&entry.2044055668=🤖+IoT+—+Séance+unique+IoT",
    note: `Location ponctuelle de matériel IoT pour une séance.\n
      + Idéal pour tester, expérimenter ou découvrir l’IoT\n
        + Kit standard fourni selon disponibilité\n
          + Réservation obligatoire 24h à l’avance`
  },
  {
    domaine: "🤖 IoT",
    service: "Pack Hebdo – 2 séances/semaine",
    description: "Location de matériel IoT sur une base hebdomadaire",
    tarif: "25 DT / mois",
    url: "https://docs.google.com/forms/d/e/1FAIpQLSdEmiWywRrgyZuweVShW9ENBvc0g7zxxyFRXjnz_hyaU0k8Dg/viewform?usp=pp_url&entry.2044055668=%F0%9F%A4%96+IoT+%E2%80%94+Pack+2+s%C3%A9ances/semaine",
    note: `Accès régulier au matériel IoT jusqu’à 2 fois par semaine.\n
    + Kit personnalisé selon le besoin du projet\n
    + Bon équilibre entre flexibilité et coût\n
    + Convient pour mini-projets ou apprentissage continu`
  },
  {
    domaine: "🤖 IoT",
    service: "Pack Hebdo – 3 séances/semaine",
    description: "Location de matériel IoT sur une base hebdomadaire",
    tarif: "35 DT / mois",
    url: "https://docs.google.com/forms/d/e/1FAIpQLSdEmiWywRrgyZuweVShW9ENBvc0g7zxxyFRXjnz_hyaU0k8Dg/viewform?usp=pp_url&entry.2044055668=%F0%9F%A4%96+IoT+%E2%80%94+Pack+3+s%C3%A9ances/semaine",
    note: `Accès régulier au matériel IoT jusqu’à 3 fois par semaine.\n
    + Kit personnalisé selon le besoin du projet\n
    + Bon équilibre entre flexibilité et coût\n
    + Convient pour mini-projets ou apprentissage continu`
  },
  {
    domaine: "🤖 IoT",
    service: "Pack Hebdo – 4 séances/semaine",
    description: "Location de matériel IoT sur une base hebdomadaire",
    tarif: "50 DT / mois",
    url: "https://docs.google.com/forms/d/e/1FAIpQLSdEmiWywRrgyZuweVShW9ENBvc0g7zxxyFRXjnz_hyaU0k8Dg/viewform?usp=pp_url&entry.2044055668=🤖+IoT+—+Pack+4+séances/semaine",
    note: `Accès régulier au matériel IoT jusqu’à 4 fois par semaine.\n
    + Kit personnalisé selon le besoin du projet\n
    + Bon équilibre entre flexibilité et coût\n
    + Convient pour mini-projets ou apprentissage continu`
  },
  {
    domaine: "🤖 IoT",
    service: "Formule mensuelle – Accès prioritaire",
    description: "Location régulière de matériel IoT avec accès prioritaire",
    tarif: "90 DT / mois",
    url: "https://docs.google.com/forms/d/e/1FAIpQLSdEmiWywRrgyZuweVShW9ENBvc0g7zxxyFRXjnz_hyaU0k8Dg/viewform?usp=pp_url&entry.2044055668=🤖+IoT+—+Formule+mensuelle+illimitée",
    note: `Formule mensuelle pour usage intensif de matériel IoT.\n
    + Idéal pour projets longs, ateliers ou multiprojets\n
    + Tarification avantageuse pour les utilisateurs réguliers`
  },
  {
    domaine: "🤖 IA & Machine Learning",
    service: "Accès API ChatGPT",
    description: "Accès à l’API OpenAI ChatGPT pour intégration dans vos projets",
    tarif: "Selon Plan choisi",
    url: "https://docs.google.com/forms/d/e/1FAIpQLSdEmiWywRrgyZuweVShW9ENBvc0g7zxxyFRXjnz_hyaU0k8Dg/viewform?usp=pp_url&entry.2044055668=%F0%9F%A4%96+IA+%26+Machine+Learning+%E2%80%94+Acc%C3%A8s+API+ChatGPT",
    note: `Permet l’utilisation de l’API ChatGPT pour automatiser dialogues, analyses, assistants virtuels, etc.\n
    + Inclut quota mensuel raisonnable\n
    + Support technique basique\n
    + Idéal pour développeurs et startups souhaitant intégrer IA conversationnelle.`
  },
  {
    domaine: "🤖 IA & Machine Learning",
    service: "Accès API Gemini",
    description: "Accès à l’API Gemini (Google AI) pour vos applications avancées",
    tarif: "Selon Plan choisi",
    url: "https://docs.google.com/forms/d/e/1FAIpQLSdEmiWywRrgyZuweVShW9ENBvc0g7zxxyFRXjnz_hyaU0k8Dg/viewform?usp=pp_url&entry.2044055668=%F0%9F%A4%96+IA+%26+Machine+Learning+%E2%80%94+Acc%C3%A8s+API+Gemini",
    note: `Accès aux modèles IA avancés de Google Gemini.\n
    + Utilisation flexible pour NLP, vision, recommandations\n
    + Support pour intégration API\n
    + Parfait pour projets IA ambitieux et R&D.`
  },
  {
    domaine: "🎨 Com & Mkg",
    service: "Accès Canva Pro",
    description: "Licence Canva Pro pour création graphique",
    tarif: "20 DT / mois",
    url:
      "https://docs.google.com/forms/d/e/1FAIpQLSdEmiWywRrgyZuweVShW9ENBvc0g7zxxyFRXjnz_hyaU0k8Dg/viewform?usp=pp_url&entry.2044055668=%F0%9F%8E%A8+Com+%26+Mkg+%E2%80%94+Acc%C3%A8s+Canva+Pro",
    note:
      "Accès complet à Canva Pro pour des créations graphiques professionnelles et une meilleure collaboration.",
  },
  {
    domaine: "☕ Services Généraux",
    service: "Pause café & snacks",
    description: "Pause avec café & snacks inclus",
    tarif: "5 DT / jour",
    url:
      "https://docs.google.com/forms/d/e/1FAIpQLSdEmiWywRrgyZuweVShW9ENBvc0g7zxxyFRXjnz_hyaU0k8Dg/viewform?usp=pp_url&entry.2044055668=%E2%98%95+Services+G%C3%A9n%C3%A9raux+%E2%80%94+Pause+caf%C3%A9+%26+snacks",
    note:
      "Service de rafraîchissements et encas pour améliorer le bien-être et la productivité au bureau.",
  },
  {
    domaine: "🚌 Transport",
    service: "Navette classe Business Essentiel",
    description: "Transport confortable avec Wi-Fi à bord",
    tarif: "8 DT / aller-retour",
    url: "https://docs.google.com/forms/d/e/1FAIpQLSdEmiWywRrgyZuweVShW9ENBvc0g7zxxyFRXjnz_hyaU0k8Dg/viewform?usp=pp_url&entry.2044055668=%F0%9F%9A%8C+Transport+%E2%80%94+Navette+classe+Business+Essentiel",
    note: `Classe Business Essentiel entre Tunis et El Mourouj 5.\n
    + Wi-Fi à bord\n
    + Paiement sur engagement de 3 séances par semaine (minimum)\n
    + Parfait pour ceux qui souhaitent travailler en déplacement.`
  },
  {
    domaine: "🚌 Transport",
    service: "Navette classe Business Confort",
    description: "Service haut de gamme avec confort supérieur",
    tarif: "10 DT / aller-retour",
    url: "https://docs.google.com/forms/d/e/1FAIpQLSdEmiWywRrgyZuweVShW9ENBvc0g7zxxyFRXjnz_hyaU0k8Dg/viewform?usp=pp_url&entry.2044055668=%F0%9F%9A%8C+Transport+%E2%80%94+Navette+classe+Business+Confort",
    note: `Classe Business Confort pour trajets premium Tunis ⇄ El Mourouj 5.\n
    + Wi-Fi + Bouteille d’eau ou Boisson offerte\n
    + Paiement sur engagement de 3 séances par semaine (minimum).\n`
  },

];


const ServicesStagiairesPage = () => {
  const [selectedDomaine, setSelectedDomaine] = useState("Tous");
  const [modal, setModal] = useState({ show: false, content: null });

  const domaines = ["Tous", ...new Set(allServices.map((s) => s.domaine))];
  const services =
    selectedDomaine === "Tous"
      ? allServices
      : allServices.filter((s) => s.domaine === selectedDomaine);

  return (
    <div style={{ padding: "20px", fontFamily: "Arial" }}>
      <h2>📋 Catalogue des Services Stagiaires</h2>

      <div style={{ marginBottom: "20px" }}>
        <label htmlFor="domaine">🌟 Filtrer par domaine : </label>
        <select
          id="domaine"
          value={selectedDomaine}
          onChange={(e) => setSelectedDomaine(e.target.value)}
        >
          {domaines.map((d, i) => (
            <option key={i} value={d}>
              {d}
            </option>
          ))}
        </select>
      </div>

      <table style={{ width: "100%", borderCollapse: "collapse" }}>
        <thead>
          <tr style={{ background: "#f7f7f7" }}>
            <th style={th}>Domaine</th>
            <th style={th}>Service</th>
            <th style={th}>Description</th>
            <th style={th}>Tarif</th>
            <th style={th}>Réserver</th>
            <th style={th}>+ d'infos</th>
          </tr>
        </thead>
        <tbody>
          {services.map((s, i) => (
            <tr key={i}>
              <td style={td}>{s.domaine}</td>
              <td style={td}>{s.service}</td>
              <td style={td}>{s.description}</td>
              <td style={td}>{s.tarif}</td>
              <td style={td}>
                <a href={s.url} target="_blank" rel="noopener noreferrer">
                  <button style={btn}>Réserver</button>
                </a>
              </td>
              <td style={td}>
                <button
                  style={btnInfo}
                  onClick={() =>
                    setModal({
                      show: true,
                      content: {
                        titre: s.service,
                        domaine: s.domaine,
                        description: s.description,
                        note: s.note,
                        tarif: s.tarif,
                        lien: s.url,
                      },
                    })
                  }
                >
                  + d'infos
                </button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>

      {/* Modal */}
      {modal.show && (
        <div style={modalOverlay}>
          <div style={modalBox}>
            <h3>{modal.content.titre}</h3>
            <p>
              <strong>Domaine :</strong> {modal.content.domaine}<br />
              <strong>Description :</strong> {modal.content.description}<br />
              <strong>Note :</strong><br />
              {modal.content.note.split('\n').map((line, i) => (
                <React.Fragment key={i}>
                  {line}
                  <br />
                </React.Fragment>
              ))}

              <strong>Tarif :</strong> {modal.content.tarif}<br />
              <a href={modal.content.lien} target="_blank" rel="noopener noreferrer">📄 Lien de réservation</a>
            </p>
            <button
              onClick={() => setModal({ show: false, content: null })}
              style={btn}
            >
              Fermer
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

const th = { padding: "10px", border: "1px solid #ccc" };
const td = { padding: "8px", border: "1px solid #ddd" };
const btn = {
  padding: "5px 10px",
  backgroundColor: "#007bff",
  color: "white",
  border: "none",
  borderRadius: "4px",
  cursor: "pointer"
};
const btnInfo = {
  ...btn,
  backgroundColor: "#6c757d",
};
const modalOverlay = {
  position: "fixed",
  top: 0,
  left: 0,
  width: "100%",
  height: "100%",
  backgroundColor: "rgba(0,0,0,0.5)",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  zIndex: 999,
};
const modalBox = {
  backgroundColor: "white",
  padding: "20px",
  borderRadius: "8px",
  maxWidth: "500px",
  width: "90%",
  boxShadow: "0 0 10px rgba(0,0,0,0.3)",
};

export default ServicesStagiairesPage;
